import React from "react";
import { OMSDropdown } from "../../../app/common/common-components/OMSDropdown";
import { OMSImageUpload } from "../../../app/common/common-components/OMSImageUpload";
import TwoFAComponent from "../TwoFAComponent";

const AccountTab = ({
  data,
  state,
  handleChange,
  handleStatusChanged,
  handleRoleChange,
  handleOfficeIDChange,
  handleTwoFactorChange,
  OnCropSubmit,
  CheckPasswordStrength,
}) => {
  return (
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label htmlFor="EmailAddress">Email address</label>
          <input
            type="email"
            className="form-control required-control"
            id="EmailAddress"
            name="EmailAddress"
            value={state.EmailAddress}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="Password">Password</label>
          <input
            type="password"
            className="form-control required-control"
            id="Password"
            name="Password"
            value={state.Password}
            onChange={handleChange}
            onKeyUp={CheckPasswordStrength}
          />
          <div className="progress" style={{ marginTop: 5 }}>
            <div
              className={"progress-bar " + state.progressbar_class}
              role="progressbar"
              aria-valuenow="100"
              aria-valuemin="0"
              aria-valuemax="100"
              style={{ width: state.progressbar_width }}
            >
              {state.progressbar_text}
            </div>
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="Role">Role</label>
          {data.actions.indexOf("role-read") < 0 ? (
            <OMSDropdown id="Role" options={data.roleDD} valueField="value" labelField="text" value={state.Role} onChange={handleRoleChange} />
          ) : (
            <input type="text" className="form-control" value={data.roleDD[0].text} readOnly="readOnly" />
          )}
        </div>

        <div className="form-group">
          <label htmlFor="OfficeID">Office</label>
          {data.actions.indexOf("office-read") < 0 ? (
            <OMSDropdown id="OfficeID" options={data.officeDD} valueField="value" labelField="text" value={state.OfficeID} onChange={handleOfficeIDChange} />
          ) : (
            <input type="text" className="form-control" value={data.officeDD[0].text} readOnly="readOnly" />
          )}
        </div>

        <TwoFAComponent data={data} handleTwoFactorChange={handleTwoFactorChange} TwoFASettings={state.TwoFASettings} />
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <OMSImageUpload src={state.PhotoUrl} width={160} height={200} compressor={true} onCropSubmit={OnCropSubmit} />
        </div>
        <div className="form-group">
          <label className="switch">
            <input type="checkbox" id="Status" name="Status" checked={state.Status === 1} onChange={handleStatusChanged} />
            <div className="slider round" />
            <span
              style={{
                marginLeft: 70,
                display: "block",
                width: 120,
                marginTop: 7,
              }}
            >
              Status: {state.Status === 1 ? "Active" : "Inactive"}
            </span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default AccountTab;
